import React from 'react';
import { convertValueToUSD } from '../../../../../../../../helpers/currency.helper';

export const itemTotalPriceTemplate = (totalAmount: number, isEnabled: boolean) => (
  <div className='flex flex-col justify-center items-center h-[64px]'>
    <span id='totalPrice' className={`font-metricR text-[14px]  cursor-default ${isEnabled ? 'text-bw08' : 'text-bw07'}`}>{convertValueToUSD(totalAmount, 2)}</span>
  </div>
);
